import React from "react";
import styled from "styled-components";

//assets
import doodle from "assets/svg/doodle-1.svg";
import doodleHeader from "assets/svg/doodle-header.svg";
import doodleWork from "assets/svg/doodle-work.svg";
import play from "assets/images/play button_Trio_Final.png";
//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components

const PlayBtnWrapper = styled.div`
position: absolute;
top: 50%;
transform: translateY(-50%);

  @media all and (max-width: ${mediaQuery.tablet}) {
    top: 70%;
    &.mid{
      top: 50% !important;
    }
  }
`;

const Button = styled.button`
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    max-width: min(48rem, calc(100vw - 4.8rem));
    border: solid 0.4rem ${colors.white};
    padding: 0 2.4rem 0 2.4rem;
    border-radius: 14rem;
    cursor: pointer;
    height: 8.2rem;
    overflow: hidden;
    transition: all 0.3s ease-in-out;

    @media all and (max-width: ${mediaQuery.tablet}) {
      height: 6.4rem;
      padding: 0 1.6rem;
      border-width: 0.3rem;
width: 6.4rem;
    }
    span{
      display: inline-block;
        position: relative;
        top: 2%;
        font-family: 'Trash', sans-serif;
        font-size: ${typographySizes.text.tekstSize7.size.desktop}rem;
        transition: all 0.3s ease-in-out;
    }

    &:hover {
      transform: scale(0.9) !important;
      transition: all 0.3s ease-in-out;
      span{
        transform: scale(0.9) !important;
        transition: all 0.3s 0.1s ease-in-out;
      }
    }
`;

const Doodle = styled.img`
    position: absolute;
    bottom: -1rem;
    left: -1rem;


`;

const DoodleHeader = styled.img`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(100%, -50%);

`;

const PlayImg = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 3.6rem;
  object-fit: contain;

 
`;

const PlayBtn = ({ buttonRef, textRef, className, onOpen, work }) => {
  return (
    <>
      <PlayBtnWrapper ref={buttonRef} className={className}>
        <Button onClick={onOpen}>
          {/* <span>Play</span> */}
          <PlayImg ref={textRef} src={play} alt="Play" />
        </Button>

        <Doodle src={doodle} alt="Doodle" />
        <DoodleHeader
          src={work ? doodleWork : doodleHeader}
          alt="Doodle Header"
        />
      </PlayBtnWrapper>
    </>
  );
};

export default PlayBtn;
